import { render } from "./DesktopIcons.vue?vue&type=template&id=29529556&bindings={}"
import script from "./DesktopIcons.vue?vue&type=script&lang=ts"
export * from "./DesktopIcons.vue?vue&type=script&lang=ts"
script.render = render

export default script